import { render, staticRenderFns } from "./tableDetails.vue?vue&type=template&id=67296cf3&"
import script from "./tableDetails.vue?vue&type=script&lang=js&"
export * from "./tableDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports